import React, { useSyncExternalStore } from 'react';
import BootSpinner from './BootSpinner';
import { getAuthPending, subscribeAuthPending } from '../utils/authPending';

// The launch loading scene, shown over everything while a sign-in / sign-up is being completed.
const AuthPendingOverlay: React.FC = () => {
  const pending = useSyncExternalStore(subscribeAuthPending, getAuthPending);
  return pending ? <BootSpinner /> : null;
};

export default AuthPendingOverlay;
